export const WasteKey = {
  wasteCategory: 'category',
  wasteType: 'type',
  data: 'data',
  wasteProduced: 'wasteproduced',
  disposalMethodData: 'disposalMethodData',
  disposalKey: {
    landfill: 'landfill',
    incineration: 'incineration',
    recycling: 'recycling',
    reclaimed: 'reclaimed',
    notTreated: 'notTreated',
    reused: 'reused'
  },
  disposalMethod: 'disposalMethod',
  treated: {
    wasteTreated: 'wasteTreated',
    treatmentCost: 'treatmentCost'
  },
  notTreated: {
    wasteNotTreated: 'wasteNotTreated'
  },
  STATUS: 'status',
  COMMENT: 'comment'
};
export const WasteLabel = {
  wasteCategory: 'Waste Category',
  wasteType: 'Waste Type',
  data: 'data',
  wasteProduced: 'Waste Produced',
  disposalMethodData: 'No. Disposal Method',
  disposalKey: {
    landfill: 'Landfill',
    incineration: 'Incineration',
    recycling: 'Recycling',
    reclaimed: 'Reclaimed',
    notTreated: 'Not Treated',
    wasteNotTreated: 'Waste Not Treated',
    reused: 'Reused'
  },
  treated: {
    wasteTreated: 'Waste Treated',
    treatmentCost: 'Treatment Cost'
  },
  notTreated: {
    wasteNotTreated: 'Waste Not Treated'
  },
  STATUS: 'Status',
  COMMENT: 'Comment',
  STATUS_COMMENTS: 'Status & Comments'
};
